import { PostOfficeContextProvider } from '@atlassian/post-office-context/post-office-context';
import { useStableObject } from '@atlassian/post-office-context/use-stable-object';

import { type ContextProviderProps } from './types';
import { DEFAULT_CONTEXT } from '../../constants';
import { type StableProvider } from '../../types';

export const StableContextProvider: StableProvider<ContextProviderProps> = ({
	context,
	children,
}) => {
	const stableContext = useStableObject({ ...DEFAULT_CONTEXT, ...context });

	return <PostOfficeContextProvider value={stableContext}>{children}</PostOfficeContextProvider>;
};
